'use client';
export default function HeroSection() {
  return (
    <section
      id="hero-1"
      className="relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #e8f5ee 0%, #d0eadb 40%, #c5e4d2 100%)',
        minHeight: '580px'
      }}>
      
      {/* Background decorative shape */}
      <div
        className="absolute inset-y-0 right-0 hidden md:block"
        style={{
          width: '55%',
          background: 'linear-gradient(135deg, rgba(14,89,50,0.06) 0%, rgba(14,89,50,0.12) 100%)',
          clipPath: 'polygon(8% 0%, 100% 0%, 100% 100%, 0% 100%)'
        }} />
      

      <div className="max-w-7xl mx-auto px-4 py-16 md:py-24 relative z-10">
        <div className="flex flex-col md:flex-row items-center gap-10">
          {/* TEXT */}
          <div className="w-full md:w-1/2 lg:w-5/12">
            <div className="mb-10">
              <h5
                className="font-bold text-sm uppercase tracking-widest mb-4"
                style={{ color: '#0e5932' }}>
                Bienvenue à COSA Ananeraie
              </h5>
              <h2
                className="font-black text-4xl md:text-5xl lg:text-6xl mb-6 leading-tight"
                style={{ color: '#1d3c5e', fontFamily: 'Lato, sans-serif' }}>
                Des Soins de Santé<br />d'Excellence
              </h2>
              <p className="text-gray-600 text-base mb-8 leading-relaxed">
                La <span style={{ color: '#0e5932' }}>Compagnie de Santé Africaine (COSA)</span> est un centre médical innovant de haute qualité, conçu pour répondre aux besoins croissants de services de santé privés en Côte d'Ivoire. Excellence, accessibilité et esthétisme au cœur de notre mission.
              </p>
              <a
                href="#about-5"
                className="inline-block px-7 py-3 rounded font-bold text-sm text-white transition-all"
                style={{ backgroundColor: '#0e5932' }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0a3f24'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#0e5932'}>
                En Savoir Plus
              </a>
            </div>
          </div>

          {/* IMAGE */}
          <div className="w-full md:w-1/2 lg:w-7/12 flex justify-center">
            <div className="relative w-full max-w-lg">
              <img
                src="https://img.rocket.new/generatedImages/rocket_gen_img_164fd0ec4-1774041139340.png"
                alt="Deux médecins africaines en blouse blanche souriant avec confiance dans une clinique moderne"
                className="w-full h-auto object-cover rounded-2xl shadow-2xl"
                style={{ maxHeight: '480px', objectPosition: 'top center' }} />
              
              {/* Decorative badge */}
              <div
                className="absolute -bottom-4 -left-4 rounded-xl p-4 shadow-xl hidden md:block"
                style={{ backgroundColor: '#fbaf45' }}>
                <div className="text-white font-black text-2xl leading-none" style={{ fontFamily: 'Lato, sans-serif' }}>70+</div>
                <div className="text-white text-xs font-semibold">Ans d'Expérience</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}